import { type ComponentProps } from 'react';

import { AutoDismissFlag as AkAutoDismissFlag } from '@atlaskit/flag';

import { wrapComponentForChoreographer } from '../utils';

export const AutoDismissFlag =
	wrapComponentForChoreographer<ComponentProps<typeof AkAutoDismissFlag>>(AkAutoDismissFlag);
